export enum Periods {
  FullDataSet = 'Full DataSet',
  DateRange = 'Date Range',
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/Periods.ts